export var Privacy;
(function (Privacy) {
    /** Unknown privacy. This value isn't used. */
    Privacy["UNKNOWN"] = "UNKNOWN";
    /** The information appears on the members' public profile pages. */
    Privacy["PUBLIC"] = "PUBLIC";
    /** Only the member can see this information. */
    Privacy["PRIVATE"] = "PRIVATE";
})(Privacy || (Privacy = {}));
export var Type;
(function (Type) {
    /** Unknown field type. This value isn't used. */
    Type["UNKNOWN"] = "UNKNOWN";
    /** A text box to write text. */
    Type["TEXT"] = "TEXT";
    /** Only a number can be entered into the field. */
    Type["NUMBER"] = "NUMBER";
    /** Only a date can be entered into the field. */
    Type["DATE"] = "DATE";
    /** Only a URL can be entered into the field. */
    Type["URL"] = "URL";
    /** Only a link from the selected social media platform can be entered into the field. */
    Type["SOCIAL"] = "SOCIAL";
})(Type || (Type = {}));
export var SocialTypeType;
(function (SocialTypeType) {
    /** Unknown social type. This value isn't used. */
    SocialTypeType["UNKNOWN"] = "UNKNOWN";
    /** Facebook social media platform. */
    SocialTypeType["FACEBOOK"] = "FACEBOOK";
    /** Instagram social media platform. */
    SocialTypeType["INSTAGRAM"] = "INSTAGRAM";
    /** LinkedIn social media platform. */
    SocialTypeType["LINKEDIN"] = "LINKEDIN";
    /** X (formerly Twitter) social media platform. */
    SocialTypeType["TWITTER"] = "TWITTER";
    /** Youtube social media platform. */
    SocialTypeType["YOUTUBE"] = "YOUTUBE";
    /** Pinterest social media platform. */
    SocialTypeType["PINTEREST"] = "PINTEREST";
    /** TikTok social media platform. */
    SocialTypeType["TIKTOK"] = "TIKTOK";
    /** DeviantArt social media platform. */
    SocialTypeType["DEVIANTART"] = "DEVIANTART";
    /** SoundCloud social media platform. */
    SocialTypeType["SOUNDCLOUD"] = "SOUNDCLOUD";
    /** Tumblr social media platform. */
    SocialTypeType["TUMBLR"] = "TUMBLR";
    /** Vimeo social media platform. */
    SocialTypeType["VIMEO"] = "VIMEO";
    /** VKontakte social media platform. */
    SocialTypeType["VKONTAKTE"] = "VKONTAKTE";
    /** Odnoklassniki social media platform. */
    SocialTypeType["ODNOKLASSNIKI"] = "ODNOKLASSNIKI";
    /** Other social media platform. */
    SocialTypeType["OTHER"] = "OTHER";
})(SocialTypeType || (SocialTypeType = {}));
export var Origin;
(function (Origin) {
    /** Unknown field origin. This value isn't used. */
    Origin["UNKNOWN"] = "UNKNOWN";
    /** Custom field created by a Wix user. */
    Origin["CUSTOM"] = "CUSTOM";
    /** Contact type of field. These are default fields that are already provided by Members Area, such as: "birth date", "position", "company". */
    Origin["CONTACT"] = "CONTACT";
    /** System fields, such as: "first name", "last name", "email", "phone", "address", and  "title". Some system fields are only available from the dashboard. */
    Origin["SYSTEM"] = "SYSTEM";
})(Origin || (Origin = {}));
export var AppliesTo;
(function (AppliesTo) {
    /** Everyone will have this field. */
    AppliesTo["ALL_MEMBERS"] = "ALL_MEMBERS";
    /** Only selected members will have this field. See the [Custom Field Application API](https://dev.wix.com/docs/rest/crm/members-contacts/members/custom-fields/custom-field-applications/introduction) for more information. */
    AppliesTo["SELECTED_MEMBERS"] = "SELECTED_MEMBERS";
})(AppliesTo || (AppliesTo = {}));
export var Section;
(function (Section) {
    /** General section. All custom fields and the following default fields are assigned to this section: "first name", "last name", "email", "phone", "birth date", "position", "company". */
    Section["GENERAL"] = "GENERAL";
    /** Social media section. The "social media" field is assigned to this section. */
    Section["SOCIAL"] = "SOCIAL";
    /** Display info section. The default "title" field is assigned to this section. */
    Section["DISPLAY_INFO"] = "DISPLAY_INFO";
    /** Address section. The default "address" field is assigned to this section. */
    Section["ADDRESS"] = "ADDRESS";
})(Section || (Section = {}));
export var State;
(function (State) {
    State["UNKNOWN"] = "UNKNOWN";
    State["ENABLED"] = "ENABLED";
    State["DISABLED"] = "DISABLED";
    State["PENDING"] = "PENDING";
    State["DEMO"] = "DEMO";
})(State || (State = {}));
export var SiteCreatedContext;
(function (SiteCreatedContext) {
    /** A valid option, we don't expose all reasons why site might be created. */
    SiteCreatedContext["OTHER"] = "OTHER";
    /** A meta site was created from template. */
    SiteCreatedContext["FROM_TEMPLATE"] = "FROM_TEMPLATE";
    /** A meta site was created by copying of the transfferred meta site. */
    SiteCreatedContext["DUPLICATE_BY_SITE_TRANSFER"] = "DUPLICATE_BY_SITE_TRANSFER";
    /** A copy of existing meta site. */
    SiteCreatedContext["DUPLICATE"] = "DUPLICATE";
    /** A meta site was created as a transfferred site (copy of the original), old flow, should die soon. */
    SiteCreatedContext["OLD_SITE_TRANSFER"] = "OLD_SITE_TRANSFER";
    /** deprecated A meta site was created for Flash editor. */
    SiteCreatedContext["FLASH"] = "FLASH";
})(SiteCreatedContext || (SiteCreatedContext = {}));
export var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    /** Default namespace for UGC sites. MetaSites with this namespace will be shown in a user's site list by default. */
    Namespace["WIX"] = "WIX";
    /** ShoutOut stand alone product. These are siteless (no actual Wix site, no HtmlWeb). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    /** MetaSites created by the Albums product, they appear as part of the Albums app. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ALBUMS"] = "ALBUMS";
    /** Part of the WixStores migration flow, a user tries to migrate and gets this site to view and if the user likes it then stores removes this namespace and deletes the old site with the old stores. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    /** Hotels standalone (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["HOTELS"] = "HOTELS";
    /** Clubs siteless MetaSites, a club without a wix website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["CLUBS"] = "CLUBS";
    /** A partially created ADI website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    /** AppBuilder for AppStudio / shmite (c). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_SITE"] = "DEV_SITE";
    /** LogoMaker websites offered to the user after logo purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["LOGOS"] = "LOGOS";
    /** VideoMaker websites offered to the user after video purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    /**
     * A draft created by HTML editor on open. Upon "first save" it will be moved to be of WIX domain.
     *
     * Meta site with this namespace will *not* be shown in a user's site list by default.
     */
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    /**
     * the user-journey for Fitness users who want to start from managing their business instead of designing their website.
     * Will be accessible from Site List and will not have a website app.
     * Once the user attaches a site, the site will become a regular wixsite.
     */
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    /** Belongs to "strategic products" company. Supports new product in the creator's economy space. */
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    /** It is to be used in the Business First efforts. */
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    /** Bookings business flow with no site. */
    Namespace["ANYWHERE"] = "ANYWHERE";
    /** Namespace for Headless Backoffice with no editor */
    Namespace["HEADLESS"] = "HEADLESS";
    /**
     * Namespace for master site that will exist in parent account that will be referenced by subaccounts
     * The site will be used for account level CSM feature for enterprise
     */
    Namespace["ACCOUNT_MASTER_CMS"] = "ACCOUNT_MASTER_CMS";
    /** Rise.ai Siteless account management for Gift Cards and Store Credit. */
    Namespace["RISE"] = "RISE";
    /**
     * As part of the branded app new funnel, users now can create a meta site that will be branded app first.
     * There's a blank site behind the scene but it's blank).
     * The Mobile company will be the owner of this namespace.
     */
    Namespace["BRANDED_FIRST"] = "BRANDED_FIRST";
    /** Nownia.com Siteless account management for Ai Scheduling Assistant. */
    Namespace["NOWNIA"] = "NOWNIA";
    /**
     * UGC Templates are templates that are created by users for personal use and to sale to other users.
     * The Partners company owns this namespace.
     */
    Namespace["UGC_TEMPLATE"] = "UGC_TEMPLATE";
    /** Codux Headless Sites */
    Namespace["CODUX"] = "CODUX";
    /** Bobb - AI Design Creator. */
    Namespace["MEDIA_DESIGN_CREATOR"] = "MEDIA_DESIGN_CREATOR";
    /**
     * Shared Blog Site is a unique single site across Enterprise account,
     * This site will hold all Blog posts related to the Marketing product.
     */
    Namespace["SHARED_BLOG_ENTERPRISE"] = "SHARED_BLOG_ENTERPRISE";
    /** Standalone forms (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["STANDALONE_FORMS"] = "STANDALONE_FORMS";
    /** Standalone events (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["STANDALONE_EVENTS"] = "STANDALONE_EVENTS";
    /** MIMIR - Siteless account for MIMIR Ai Job runner. */
    Namespace["MIMIR"] = "MIMIR";
    /** Wix Twins platform. */
    Namespace["TWINS"] = "TWINS";
    /** Wix Nano. */
    Namespace["NANO"] = "NANO";
})(Namespace || (Namespace = {}));
export var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
    DeleteStatus["PURGED_EXTERNALLY"] = "PURGED_EXTERNALLY";
})(DeleteStatus || (DeleteStatus = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map